export const collectionQueryKeyPrefix = (customerOrderId) => (
  ['erp', 'customerOrder', 'collection', customerOrderId]
);

export const collectionQueryKey = (customerOrderId, part) => (
  [...collectionQueryKeyPrefix(customerOrderId), part]
);
